const INTERNAL_API_CONFIG = {
	BASE_URL: 'https://proplanconnect-dyb3che9gtfqdmgj.westcentralus-01.azurewebsites.net/api',
	FRONTEND_URL: 'https://ppc.nsieng.com/',
	TENANT_ID: 'ba7cfdf3-def9-464a-9fd2-1d7236bf7edd',
	CLIENT_ID: '60531a59-7795-448d-ba3e-a8bfd113988d',
	API_CLIENT_ID: '60531a59-7795-448d-ba3e-a8bfd113988d',
	API_SCOPE: 'api://60531a59-7795-448d-ba3e-a8bfd113988d/.default',
	DEPLOYMENT_AUDIENCE: 'internal',
};

const EXTERNAL_API_CONFIG = {
	BASE_URL: 'https://ppcexternal-hcdecef8cgefgwhd.westcentralus-01.azurewebsites.net/api',
	FRONTEND_URL: 'https://ext.ppc.nsieng.com/',
	TENANT_ID: 'ddfc80eb-544f-4448-9c7e-704f398517fd',
	CLIENT_ID: '7c6b5488-83f0-4d24-ae18-a5ca0e948887',
	API_CLIENT_ID: '7c6b5488-83f0-4d24-ae18-a5ca0e948887',
	API_SCOPE: 'api://7c6b5488-83f0-4d24-ae18-a5ca0e948887/.default',
	DEPLOYMENT_AUDIENCE: 'external',
};

const deploymentTarget = String(process.env.REACT_APP_DEPLOYMENT_TARGET || 'internal').trim().toLowerCase();

const API_CONFIG = deploymentTarget === 'external' ? EXTERNAL_API_CONFIG : INTERNAL_API_CONFIG;

export default API_CONFIG;